import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/location_new/uk-mobile/experience_growth_tek.webp";

function Businessgrowthuk({ handleShow }) {
  return (
    <section
      className="business_growth_uk p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={9} lg={9} xl={7} xxl={7} className="">
            <h2>
              Experience App-Driven Business <span>Growth with Tekrevol</span>
            </h2>
            <p>
              Propel your business to new heights with Tekrevol’s custom app
              development in the UK. Leverage the experience of our top-tier{" "}
              <Link to="/uk/mobile-app-development-company-uk">
                app developers in the UK
              </Link>{" "}
              and drive growth, enhance customer engagement, and carve your
              unique digital identity.
            </p>
            <div className="app_growth_main">
              <div className="app_growth_item">
                <div className="app_all">
                  <div className="app_growth_img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/get_phone_icon.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={57}
                      height={57}
                    />
                  </div>
                  <div className="app_growth_num">
                    <Link to="tel:+441223926620">+441-223-926620</Link>
                  </div>
                </div>
              </div>
              <div className="app_growth_item">
                <h5>OR</h5>
              </div>
              <div className="app_growth_item">
                <button
                  style={{ background: "#F47a14", color: "#fff" }}
                  onClick={handleShow}
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Talk Our App Development Team
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Businessgrowthuk;
